import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs'

window.customSwiper.swiper = Swiper;

const throttleDebounce = (fn, delay) => {
  let timeoutId = null;
  let lastExecution = 0;

  return function (...args) {
    const now = Date.now();

    if (now - lastExecution >= delay) {
      fn(...args);
      lastExecution = now;
    } else {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn(...args);
        lastExecution = Date.now();
      }, delay - (now - lastExecution));
    }
  };
}

const safeJSONParse = (str, respondWithOnFail = false) => {
  if (typeof str !== 'string') {
    return respondWithOnFail;
  }
  try {
    return JSON.parse(str);
  } catch (e) {
    return respondWithOnFail;
  }
}

const DESKTOP_BREAKPOINT = 990;

// Standard Swiper init
export const initSwiper = () => {
  const swipers = document.querySelectorAll('[data-swiper]');
  const thumbSwipers = [];

  if (!swipers.length) return;

  window.customSwiper.swiperObjects = [];

  swipers.forEach(swiper => {
    const slides = swiper.querySelectorAll('.swiper-slide');
    let config = swiper.dataset.swiperConfig ? safeJSONParse(swiper.dataset.swiperConfig, false) : {};
    !config ? console.error('Error in Swiper JSON') : null;
    if (slides.length && config) {
      // We then add the modules to the config
      config = { ...config };

      swiper.classList.add('swiper--active');
      const newSwiper = new Swiper(swiper, config);
      // If the swiper is for thumbs we push it to the thumbSwipers array
      if (swiper.dataset.swiperThumbs) {
        thumbSwipers.push(newSwiper);
      }
      window.customSwiper.swiperObjects.push(newSwiper);
    }
  });
};

// Init swipers for mobile only
export const initSwiperMob = () => {
  const swipers = document.querySelectorAll('[data-swiper-mob]');
  if (!swipers.length) return;
  window.customSwiper.swiperMobileObjects = [];

  const initSwiperOnMobile = () => {
    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      swipers.forEach(swiper => {
        const slides = swiper.querySelectorAll('.swiper-slide');
        let config = swiper.dataset.swiperConfig ? safeJSONParse(swiper.dataset.swiperConfig, false) : {};
        !config ? console.error('Error in Swiper JSON') : null;
        if (slides.length && config) {
          config = { ...config };
          swiper.classList.add('swiper--mob-active');
          const newSwiper = new Swiper(swiper, config);
          window.customSwiper.swiperMobileObjects.push(newSwiper);
        }
      });
    } else {
      if (window.customSwiper.swiperMobileObjects) {
        window.customSwiper.swiperMobileObjects.forEach(swiper => {
          swiper.destroy();
        });
        const keys = Object.keys(window.customSwiper.swiperMobileObjects);
        keys.forEach(key => window.customSwiper.swiperMobileObjects[key].destroy());
        window.customSwiper.swiperMobileObjects = [];
      }
    }
  };
  initSwiperOnMobile();

  window.addEventListener('resize', throttleDebounce(() => {
    initSwiperOnMobile();
  }, 500)
  );
};

initSwiper();
initSwiperMob();

document.addEventListener('shopify:section:load', () => {
  initSwiper();
  initSwiperMob();
});
